import { render, staticRenderFns } from "./TokenAuth.vue?vue&type=template&id=003f4000"
import script from "./TokenAuth.vue?vue&type=script&lang=js"
export * from "./TokenAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports